import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api/auth";
import successSound from "../sounds/login.mp3";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const audioRef = useRef(new Audio(successSound));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const { access_token, access_level } = await login(username, password);
      onLogin(access_token, access_level);
      navigate("/profile");
      // audioRef.current.play();
    } catch (err) {
      setError("Неверный логин или пароль");
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <span className="login-brand-mark">S</span>
          <div>
            <p className="login-brand-name">Schedule</p>
            <p className="login-brand-sub">Система расписания</p>
          </div>
        </div>

        <h1 className="login-title">Вход в систему</h1>
        <p className="login-hint">Введите логин и пароль сотрудника</p>

        {error && <div className="login-error">{error}</div>}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label htmlFor="login-username">Логин</label>
            <input
              id="login-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-control"
              placeholder="username"
              autoComplete="username"
              required
            />
          </div>
          <div className="login-field">
            <label htmlFor="login-password">Пароль</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-control"
              autoComplete="current-password"
              required
            />
          </div>
          <button
            type="submit"
            className="btn login-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Вход..." : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
